import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const PhotoModal = ({ isOpen, onClose, photoUrl, photoData }) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} style={{ paddingTop: "40px" }}>
      <ModalHeader toggle={onClose}>Foto Rumah</ModalHeader>
      <ModalBody style={{ maxHeight: "60vh", overflowY: "auto", textAlign: "center" }}>
       
        {photoUrl ? (
          <img src={photoUrl} alt="Foto Rumah" className="img-fluid" style={{ maxWidth: "100%", maxHeight: "400px" }} />
        ) : (
          <p>Foto tidak tersedia</p>
        )}
        
      </ModalBody>
       <div className="text-center mb-3">
       {photoData && (
          <div className="mb-3">
            <p className="mb-2">
              <strong>Nama:</strong> {photoData.namaLengkapKK || 'Tidak tersedia'}
            </p>
             <p className="mb-2">
              <strong>NIK:</strong> {photoData.nomorKTP || 'Tidak tersedia'}
            </p>
            <p className="mb-3">
              <strong>Alamat:</strong> {photoData.alamatRumah || 'Tidak tersedia'}
            </p>
          </div>
        )}
        </div>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>Tutup</Button>
      </ModalFooter>
    </Modal>
  );
};

export default PhotoModal;